import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'naas-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit {
  // This toggles the hamburger menu
  hamburgerToggle() {
    const navMenu = document.getElementById('navMenu');
    const hamburgerButton = document.getElementById('hamburgerButton');
    const contactDropdown = document.getElementById('contactDropdown');
    const currentState = hamburgerButton?.getAttribute('data-state');
    if (
      navMenu !== null &&
      typeof navMenu !== 'undefined' &&
      contactDropdown !== null &&
      typeof contactDropdown !== 'undefined'
    ) {
      if (typeof currentState === 'undefined' || currentState === 'closed') {
        navMenu.className += ' responsive';
        navMenu.setAttribute('aria-expanded', 'true');
        hamburgerButton?.setAttribute('data-state', 'opened');
        hamburgerButton?.setAttribute('aria-expanded', 'true');
        contactDropdown.setAttribute('aria-expanded', 'true');
      } else {
        navMenu.className = 'topnav';
        navMenu.setAttribute('aria-expanded', 'false');
        hamburgerButton?.setAttribute('data-state', 'closed');
        hamburgerButton?.setAttribute('aria-expanded', 'false');
        contactDropdown.setAttribute('aria-expanded', 'false');
      }
    }
  }

  // The contact-us sub-menu "aria-expanded" toggle
  setExpanded(expanded = 'false') {
    const navMenu = document.getElementById('contactDropdown');
    if (navMenu !== null && typeof navMenu !== 'undefined') {
      navMenu.setAttribute('aria-expanded', expanded);
    }
  }

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const links = this.elRef.nativeElement.querySelectorAll('.topnav a');
    links.forEach((link: HTMLAnchorElement) => {
      if (link.href === window.location.href) {
        this.renderer.addClass(link, 'current-page');
        this.renderer.setAttribute(link, 'aria-current', 'page');
      }
    });
  }
}
